export default {
  data () {
    return {
      scopes: process.env.SCOPES,
      isIntercomShutdown: false
    }
  },
  watch: {
    'userData.name' (name) {
      this.$intercom.update({ name })
    },
    'userData.email' (email) {
      this.$intercom.update({ email })
    },
    'userData.intercom' () {
      this.$intercom.shutdown()
      this.$nextTick(() => {
        this.updateUserDetails()
      })
    },
    'isLoggedIn' () {
      this.$intercom.shutdown()
      this.$nextTick(() => {
        this.updateUserDetails()
      })
    },
    '$route' (params) {
      // If the route has explicitly disabled intercom
      if (params.meta && params.meta.intercom === false) {
        this.isIntercomShutdown = true
        this.$intercom.shutdown()
      }
      else if (this.isIntercomShutdown) {
        this.updateUserDetails()
      }
    }
  },
  computed: {
    scope () {
      return this.$store.getters.getPortal
    },
    cobrowsePayload () {
      if (!this.isLoggedIn) {
        return {}
      }
      return {
        user_name: this.userData.name,
        user_id: this.userData.id,
        user_email: this.userData.email
      }
    }
  },
  methods: {
    updateUserDetails () {
      if (this.isLoggedIn && this.userData.intercom) {
        const intercomPayload = {
          name: this.userData.name,
          email: this.userData.email,
          user_hash: this.userData.intercom,
          hide_default_launcher: true,
          vertical_padding: 0,
          portal: this.scope === process.env.SCOPES.business ? 'Professional' : 'Residential'
        }
        if (this.scope === this.scopes.business) {
          intercomPayload['company.name'] = this.company.company_name
        }
        this.$intercom.boot(intercomPayload)
        if (window.CobrowseIO) {
          window.CobrowseIO.customData = this.cobrowsePayload
        }
      }
      else {
        this.$intercom.boot({
          hide_default_launcher: this.$q.platform.is.nativeMobile,
          vertical_padding: 0
        })
        if (window.CobrowseIO) {
          window.CobrowseIO.customData = {}
        }
      }
      this.isIntercomShutdown = false
    }
  },
  mounted () {
    this.updateUserDetails()
  },
  beforeUnmount () {
    this.$intercom.shutdown()
  }
}
